import { render, staticRenderFns } from "./SalaCalendarioNuevo.vue?vue&type=template&id=6012aac1&scoped=true"
import script from "./SalaCalendarioNuevo.vue?vue&type=script&lang=js"
export * from "./SalaCalendarioNuevo.vue?vue&type=script&lang=js"
import style0 from "./SalaCalendarioNuevo.vue?vue&type=style&index=0&id=6012aac1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6012aac1",
  null
  
)

export default component.exports